import { render, staticRenderFns } from "./MSProposalInsureds.vue?vue&type=template&id=5162ac8b"
import script from "./MSProposalInsureds.vue?vue&type=script&lang=js"
export * from "./MSProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports